module.exports = __webpack_public_path__ + "img/6689344.png";